import { render } from "./acceptStorage.vue?vue&type=template&id=21141260&scoped=true"
import script from "./acceptStorage.vue?vue&type=script&lang=js"
export * from "./acceptStorage.vue?vue&type=script&lang=js"

import "./acceptStorage.vue?vue&type=style&index=0&id=21141260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21141260"]])

export default __exports__